import { Image, UIText1, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IAdvantageItemProps {
  title: string;
  shortDescription: string;
  imgUrl?: string;
}

export function NewbuildingDecorationItem({ title, imgUrl, shortDescription }: IAdvantageItemProps) {
  return (
    <div data-testid="NewbuildingDecorationItem" className={styles['container']}>
      <div className={styles['image']}>
        {!!imgUrl && <Image src={imgUrl} width="100%" height="100%" objectFit="cover" borderRadius="4px" />}
      </div>
      <div className={styles['title']}>
        <UIText1 fontWeight="bold">{title}</UIText1>
      </div>
      {shortDescription && <UIText2>{shortDescription}</UIText2>}
    </div>
  );
}
